import type { ResponseData } from '../useAlertBanner/useAlertBannerData';

export const shouldRender = (data: ResponseData) => {
  return data.currentAccount.isUnlimited;
};

export const Component = function UnlimitedAccount() {
  // This should literally render nothing since the account `isUnlimited`.
  return null;
};
